const exportedObject = {
  authUserData: {},
  authUserLoading: false,
  authUserError: null,

  nuevaSesionData: {},
  nuevaSesionLoading: false,
  nuevaSesionError: null,

  logoutUserData: {},
  logoutUserLoading: false,
  logoutUserError: null,
};

export default exportedObject;